import { inject } from '@angular/core';
import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { SeahorseFormBuilder } from '@seahorse/forms';

export function createResetPasswordForm() {
  const fb = inject(SeahorseFormBuilder);

  return fb.group(
    {
      newPassword: fb.control<string | null>(null, [Validators.required]),
      confirmPassword: fb.control<string | null>(null, [Validators.required]),
    },
    { validators: mustMatchValidator }
  );
}

function mustMatchValidator(group: AbstractControl): ValidationErrors | null {
  const newPassword = group.get('newPassword')?.value;
  const confirmPassword = group.get('confirmPassword')?.value;

  return newPassword === confirmPassword ? null : { mustMatch: true };
}
